import React from "react";
import Label from "./Label";
import Reveal from "./Reveal";

// Shared masthead for content pages: eyebrow, title, optional lede.
// Every content page opened with a hand-rolled copy of this block; keeping it
// in one place is what makes the set read as one system.
export default function PageHeader({ eyebrow, title, lede }) {
  return (
    <section className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 pt-16 lg:pt-24 pb-10 lg:pb-12">
      <Reveal>
        {eyebrow && <Label>{eyebrow}</Label>}
        <h1
          className={`font-hanken font-extrabold text-ink tracking-[-0.03em] leading-[1.08] text-[clamp(2.2rem,4.4vw,3.6rem)] ${
            eyebrow ? "mt-5" : ""
          }`}
        >
          {title}
        </h1>
        {lede && (
          <p className="mt-6 max-w-3xl text-lg leading-[1.75] text-steel">{lede}</p>
        )}
      </Reveal>
    </section>
  );
}
